import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27527153"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "box",
  class: "map-box"
}
const _hoisted_2 = { class: "form-footer xag-page__footer device-replace-button-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_fault_points = _resolveComponent("fault-points")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "选择服务网点" }),
    (_ctx.locationInfo?.lat && _ctx.locationInfo?.lng)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, null, 512),
          _createVNode(_component_van_search, {
            class: "filter-box",
            modelValue: _ctx.keywords,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywords) = $event)),
            modelModifiers: { trim: true },
            placeholder: "输入关键词"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_fault_points, {
            class: "xag-container",
            keywords: _ctx.keywords,
            onSwitchPoint: _ctx.onSwitchPoint
          }, null, 8, ["keywords", "onSwitchPoint"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: _ctx.onComfirmSelect
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确定")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}